<div class="row p-2 mb-3 align-items-center">
  <div class="col-12 col-md-7 text-start">
    <div class="page-title-heading">
      <div class="page-title-icon"><i class="fa-solid fa-clipboard-check"></i></div>
      <div>
        Validation des bulletins
        <div class="page-title-subheading">Bulletins en attente de validation</div>
      </div>
    </div>
  </div>
  <div class="col-12 col-md-5 text-end">
    <app-header></app-header>
  </div>
</div>

<div  class="card mb-3">
  <div class="card-body py-3">
    <div class="row g-3 align-items-end">
      <div class="col-12 col-md-6">
        <label for="" class="form-label mb-0">Choisir la classe</label>
        <select class="form-select form-select-sm" (change)="loadCompositions1($event)" >
            <option selected disabled></option>
            <option *ngFor="let classroom of classrooms" [value]="classroom?.id">{{classroom?.name}}</option>
        </select>
      </div>
      <div class="col-12 col-md-6">
        <label for="" class="form-label mb-0">Choisir la période</label>
        <select class="form-select form-select-sm" [(ngModel)]="periodId" name="periodId" (change)="loadCompositions2($event)">
            <option selected disabled></option>
            <option *ngFor="let p of periods" [value]="p?.id">{{p?.name}}</option>
        </select>
      </div>
    </div>
  </div>
</div>
<div class="container">
    <div class="card">
        <div class="card-body">
           <div class="row">
            <div class="col-12 col-md-3">
                <ul class="list-group" style=" height: 50vh; overflow-y: scroll;">
                    <li class="list-group-item {{currentDetails?.id == d.id ?'active':''}}" (click)="currentDetails=d" *ngFor="let d of data; let i=index" style="cursor: pointer;">
                        <strong>{{d.lastname}}</strong>  {{d.firstname}}
                        <i *ngIf="d.bulletin?.is_confirmed && role=='dg'" class="fa fa-check text-success"></i>
                        <i *ngIf="d.bulletin?.is_valid && role=='de'" class="fa fa-check text-success"></i>
                    </li>
                  </ul>
                  <div class="text-center">
                    <button [disabled]="loading"  *ngIf="role=='dg' && data.length!=0 && canPublish" class="btn btn-sm btn-primary" (click)="publish()">Publier les résultats</button>

                  </div>
            </div>
            <div class="col-12 col-md-9">
                <p>{{data!.length}} élément(s)</p>
                <div class="table-responsive">
                <table class="table table-sm table-striped table-bordered">
                    <thead>
                        <tr>
                            <th rowspan="2">#</th>
                            <th rowspan="2">Matière</th>
                            <th colspan="4">Moyenne</th>
                            <th rowspan="2">Appréciation</th>
    
                        </tr>
                        <tr>
                            <th>Elève</th>
                            <th>Classe</th>
                            <th>-</th>
                            <th>+</th>
    
                        </tr>
                       
                    </thead>
                    <tbody>
                        <tr *ngFor="let d of currentDetails?.details; let i=index">
                            <td >
                                <div class="">
                                    {{i+1}}
                                </div>
                            </td>
                            <td >
                                <strong>{{d.course}}</strong> <br>
                                <small>{{d.professor}}</small>
                            </td>
                            <td >
                                {{d.stu_average}}
                            </td>
                            <td >
                                {{d.class_average}}
                            </td>
                            <td >
                                {{d.low_average}}
                            </td>
                            <td >
                                {{d.high_average}}
                            </td>
                           
                            <td >
                                <p>{{d.appreciation}}</p>
                            </td>
                            
                        </tr>
                    </tbody>
                </table>
                </div>
             
            </div>
           </div>
           <div  class="d-flex justify-content-around ">
            <button *ngIf="!currentDetails?.bulletin?.is_valid && role=='de' && currentDetails!=undefined" [disabled]="loading" class="btn btn-sm btn-primary" (click)="setValidate(currentDetails?.bulletin?.id)">Valider </button>
            <button  *ngIf="!currentDetails?.bulletin?.is_confirmed && role=='dg' && currentDetails!=undefined" [disabled]="loading"  class="btn btn-sm btn-primary" (click)="setConfirmed(currentDetails?.bulletin?.id)">Confirmer</button>
        
        </div>
        </div>
    </div>
</div>